import { Component, Input } from '@angular/core';

@Component({
  selector: 'cert-linked-educator-description',
  template: `
    @if (isPrimaryEducator) {
      <span [certTooltip]="'This record has been identified the primary record in this group.'"
        ><i class="bi bi-star-fill text-primary"></i> Primary Educator</span
      >
    } @else {
      <span [certTooltip]="'This record has been identified as a duplicate in this group.'"
        ><i class="bi bi-exclamation-diamond-fill text-warning"></i> Duplicate Educator</span
      >
    }
  `,
  styles: ``,
  standalone: false,
})
export class LinkedEducatorDescriptionComponent {
  @Input() isPrimaryEducator!: boolean;
}
